import { MutationTree } from "vuex";
import { ActivityLogState } from "./types";

export const mutations: MutationTree<ActivityLogState> = {

};
